function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_67703",
  d: "M15.184,25.128A10.281,10.281,0,1,0,4.9,14.847,10.348,10.348,0,0,0,15.184,25.128Zm-3.39-5.946a.94.94,0,0,1-.944-.954.906.906,0,0,1,.288-.656l2.7-2.714-2.7-2.7a.906.906,0,0,1-.288-.656.932.932,0,0,1,.944-.945.906.906,0,0,1,.676.268l2.714,2.7,2.724-2.714a.924.924,0,0,1,.676-.278.935.935,0,0,1,.656,1.611l-2.7,2.714,2.7,2.7a.958.958,0,0,1,.278.666.942.942,0,0,1-.954.954.97.97,0,0,1-.686-.278l-2.694-2.694L12.49,18.9A.922.922,0,0,1,11.794,19.182Z",
  transform: "translate(-4.903 -4.566)",
  fill: "currentColor"
});

function SvgXSignFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20.571 20.561",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXSignFilled);
export default __webpack_public_path__ + "static/media/x-sign-filled.483c13ac.svg";
export { ForwardRef as ReactComponent };